module.exports = __webpack_public_path__ + "media/fonts/calibri/Calibri-Light-0d717c4bf80cbb556bf87777fef7d09e.ttf";